/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_AddInputs */

const en_fw_notify_add = /** @type {(inputs: Fw_Notify_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add channel`)
};

const id_fw_notify_add = /** @type {(inputs: Fw_Notify_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah kanal`)
};

/**
* | output |
* | --- |
* | "Add channel" |
*
* @param {Fw_Notify_AddInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_add = /** @type {((inputs?: Fw_Notify_AddInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_AddInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_add(inputs)
	return en_fw_notify_add(inputs)
});